module.exports = __webpack_public_path__ + "img/phone.ef95d83b.svg";